var exports = {
  "standard": "xf0b3b88a--af9318--standard",
  "light": "xf0b3b88a--af9318--light",
  "outline": "xf0b3b88a--af9318--outline",
};

module.exports = exports;
